import { getChapterContract } from './chapterContracts'
import { assessBriefReadiness } from './briefReadiness'
import type { ThesisBrief } from './types'

export type ChapterAccess =
  | { ok: true }
  | {
      ok: false
      code: 'BRIEF_INCOMPLETE' | 'DEPENDENCY' | 'LOCKED' | 'NEEDS_REVISION'
      message: string
    }

/** 写某章正文前的访问控制（真实论证顺序） */
export function canDraftChapter(brief: ThesisBrief, chapterIndex: number): ChapterAccess {
  const readiness = assessBriefReadiness(brief)
  // 第1章允许边写边收问题；第2章起 Brief 必须就绪
  if (chapterIndex >= 2 && !readiness.ready) {
    return {
      ok: false,
      code: 'BRIEF_INCOMPLETE',
      message: `开题卡未就绪（${readiness.score}%）。请先补：${readiness.gaps.map((g) => g.label).join('、')}`,
    }
  }

  const gate = brief.chapterGates[String(chapterIndex)]
  if (gate?.status === 'needs_revision') {
    return {
      ok: false,
      code: 'NEEDS_REVISION',
      message: `第${chapterIndex}章门控未通过，请先按编审意见修改并重新提交门控。`,
    }
  }
  if (gate?.status === 'locked') {
    return {
      ok: false,
      code: 'LOCKED',
      message: `第${chapterIndex}章尚未解锁。请先让前序章通过门控。`,
    }
  }

  const contract = getChapterContract(chapterIndex)
  if (contract) {
    for (const dep of contract.dependsOn) {
      const depGate = brief.chapterGates[String(dep)]
      if (depGate?.status !== 'passed') {
        return {
          ok: false,
          code: 'DEPENDENCY',
          message: `第${chapterIndex}章依赖第${dep}章通过门控。`,
        }
      }
    }
  }

  return { ok: true }
}

/** 某章 passed 后解锁下一章 */
export function unlockNextChapter(brief: ThesisBrief, passedIndex: number): ThesisBrief {
  const next = { ...brief, chapterGates: { ...brief.chapterGates } }
  const cur = next.chapterGates[String(passedIndex)] || { status: 'passed' as const, summary: '' }
  next.chapterGates[String(passedIndex)] = { ...cur, status: 'passed' }
  const n = passedIndex + 1
  if (n <= 6) {
    const ng = next.chapterGates[String(n)] || { status: 'locked' as const, summary: '' }
    if (ng.status === 'locked') {
      next.chapterGates[String(n)] = { ...ng, status: 'open' }
    }
  }
  return next
}
